<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CHAP-TITLE">Christmas Joy</h1>
<p class="BOD2">A delightful selection of Christmas decorations to add extra cheer to your festivities. Mix and match – anything goes!</p>
<p class="IMAGE"><img alt="" src="images/C1-9.jpg"/></p>
<p class="IMAGE"><img alt="" src="images/C1-10.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1-5.vue?5d0dc478